module.exports = __webpack_public_path__ + "img/COM-A-3-II.53ed4e38.png";